import React from "react";

const Button = () => {
      return (
            <div className="button1">
                  <b className="sign-up-now">Sign up Now</b>
            </div>
      );
};

export default Button;